import { z } from "zod";

export const ResourceRefSchema = z.object({
  id: z.string(),
  title: z.string(),
});

// --- Tasa específica por producto o colección ---
// Permite sobrescribir la tasa global para SKUs o categorías concretas.

export const SpecificTaxRateSchema = z.object({
  id: z.string(),
  name: z.string().default(""),
  rate: z.number().min(0).max(100).default(0),
  products: z.array(ResourceRefSchema).default([]),
  collections: z.array(ResourceRefSchema).default([]),
});

// --- Schema completo de tax (admin / DB) ---
// Incluye specific_rates y defaults — usado al guardar/leer la config en DB.

export const TaxSettingsSchema = z.object({
  enabled: z.boolean().default(false),
  apply_to: z
    .enum(["products_only", "products_and_shipping"])
    .default("products_only"),
  rate: z.number().min(0).max(100).default(0),
  name: z.string().default(""),
  included_in_price: z.boolean().default(false),
  country_codes: z.array(z.string()).default([]),
  specific_rates: z.array(SpecificTaxRateSchema).default([]),
});

// =========================================================================
// TYPE EXPORTS
// =========================================================================

export type TaxSettings = z.infer<typeof TaxSettingsSchema>;
export type SpecificTaxRate = z.infer<typeof SpecificTaxRateSchema>;
export type ResourceRef = z.infer<typeof ResourceRefSchema>;
